import { languages } from './constants';

export const isoCodes = languages.reduce((prev, current) => {
  const language = prev;
  language[current.locale] = current.isoCode;
  return language;
}, {});
